// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px;
  background-color: #001d4a;

  width: 100%;
  height: 10vh;
  position: fixed;
  top: 0;
  z-index: 1000 !important;
  opacity: 1 !important;
}

.logo img {
  height: 70px;
  width: 70px;
  border-radius: 50%;
  margin-left: 30%;
}

.nav-links {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #001d4a;
  z-index: 10;
  width: 100%;
  justify-content: flex-start;
  padding: 0;
  margin-left: 180px;
}

.nav-links.open {
  display: flex;
}

.nav-links li {
  margin-left: 20px;
  padding: 10px 15px;
  border-radius: 5px;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.nav-links li:hover {
  background-color: #79c42b;
  color: white;
}

.nav-links a {
  text-decoration: none;
  color: white;
  font-size: 1.2rem;
}

.nav-links li.dropdown {
  position: relative;
}

.nav-links li.dropdown a {
  display: inline-flex;
  align-items: center;
  padding-right: 10px;

  justify-content: flex-start;
}

.nav-links li.dropdown .dropdown-arrow {
  margin-left: 5px;
  color: #fff;
  font-size: 1.2rem;
  cursor: pointer;
  transition: transform 0.3s ease;
  flex-shrink: 0;
}

.nav-links li.dropdown.open a .dropdown-arrow {
  transform: rotate(180deg);
}

.nav-links li.dropdown .dropdown-menu {
  display: none;
  position: absolute;
  top: 130%;
  left: 0;
  background-color: #001d4a;
  box-shadow: 0 10px 16px rgba(0, 0, 0, 0.2);
  padding: 0;
  margin: 0;
  min-width: 200px;
  z-index: 1;
  list-style-type: none;
}

.nav-links li.dropdown .dropdown-menu.show {
  display: block;
}

.nav-links li.dropdown .dropdown-menu li {
  padding: px 8px;
  margin: 0;
  border-bottom: 1px solid #ffffff30;
}

.nav-links li.dropdown .dropdown-menu li:last-child {
  border-bottom: none;
}

.nav-links li.dropdown .dropdown-menu li a {
  color: white;
  text-decoration: none;
  font-size: 1rem;
}

.nav-links li.dropdown .dropdown-menu li a:hover {
  background-color: #79c42b;
  color: white;
}

.hamburger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  z-index: 20;
}

.hamburger .line {
  width: 20px;
  height: 3px;
  background-color: white;
  margin: 3px 0;
  gap: 3px;
  border-radius: 15%;
  z-index: 20;
}

.navbar button {
  background-color: transparent;
  color: white;
  border: none;
  padding: 0px 0px;
  font-size: 1.2rem;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, color 0.3s ease, transform 0.3s ease;
}

.navbar button:hover {
  background-color: #79c42b;
  color: white;
  transform: scale(1.05);
}

@media (max-width: 768px) {
  .hide-navbar-mobile {
    display: none !important;
  }
}

@media (max-width: 768px) {
  .hamburger {
    display: flex;
    margin-right: 10%;
  }
  .logo img {
    margin-left: 30%;
  }
  .navbar {
    padding: none;
    justify-content: space-evenly;
    gap: 200px;
    z-index: 1000;
  }
  .nav-links {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 70px;
    left: 30%;
    transform: translateX(-50%);
    background-color: #001d4a;
    width: 60%;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 999;
  }

  .nav-links.open {
    display: flex;
  }

  .nav-links li {
    padding: 8px 5px;
    border-radius: 5px;

    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
    width: 80%;
  }

  .nav-links li a {
    font-size: 1.2rem;
    text-align: left;
  }

  .nav-links li.dropdown {
    width: 100%;
  }

  .nav-links li.dropdown a {
    display: inline-flex;
    align-items: center;
    padding-right: 10px;
    justify-content: flex-start;
  }

  .nav-links li.dropdown .dropdown-arrow {
    margin-left: 5px;
    font-size: 0.9rem;
    cursor: pointer;
  }

  .nav-links li.dropdown .dropdown-menu {
    position: absolute;
    top: 100%;
    margin-left: -60px;
    background-color: #001d4a;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
    min-width: 50%;
    text-align: left;
  }

  .nav-links li.dropdown.open .dropdown-menu {
    display: block;
  }

  .nav-links li.dropdown .dropdown-menu li {
    padding: 8px 10px;
    border-bottom: 1px solid #fff;
  }

  .nav-links li.dropdown .dropdown-menu li:last-child {
    border-bottom: none;
  }

  .nav-links li.dropdown .dropdown-menu li a {
    color: white;
    text-decoration: none;
    font-size: 1rem;
  }

  .nav-links li.dropdown .dropdown-menu li a:hover {
    background-color: #79c42b;
    color: white;
  }
}

@media (min-width: 769px) {
  .hamburger {
    display: none;
  }

  .nav-links {
    display: flex;
    flex-direction: row;
    gap: 20px;
    position: static;
    margin-right: 20px;
  }

  .nav-links li {
    margin-left: 20px;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .nav-links li:hover {
    background-color: #79c42b;
    color: white;
  }

  .nav-links a {
    text-decoration: none;
    color: white;
    font-size: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;;EAEzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,MAAM;EACN,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;;EAEnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,0CAA0C;EAC1C,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,UAAU;IACV,aAAa;EACf;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,yBAAyB;IACzB,UAAU;IACV,0CAA0C;IAC1C,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;;IAElB,eAAe;IACf,uDAAuD;IACvD,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,yCAAyC;IACzC,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,uDAAuD;EACzD;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":[".navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0px;\n  background-color: #001d4a;\n\n  width: 100%;\n  height: 10vh;\n  position: fixed;\n  top: 0;\n  z-index: 1000 !important;\n  opacity: 1 !important;\n}\n\n.logo img {\n  height: 70px;\n  width: 70px;\n  border-radius: 50%;\n  margin-left: 30%;\n}\n\n.nav-links {\n  display: flex;\n  flex-direction: row;\n  list-style-type: none;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background-color: #001d4a;\n  z-index: 10;\n  width: 100%;\n  justify-content: flex-start;\n  padding: 0;\n  margin-left: 180px;\n}\n\n.nav-links.open {\n  display: flex;\n}\n\n.nav-links li {\n  margin-left: 20px;\n  padding: 10px 15px;\n  border-radius: 5px;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.nav-links li:hover {\n  background-color: #79c42b;\n  color: white;\n}\n\n.nav-links a {\n  text-decoration: none;\n  color: white;\n  font-size: 1.2rem;\n}\n\n.nav-links li.dropdown {\n  position: relative;\n}\n\n.nav-links li.dropdown a {\n  display: inline-flex;\n  align-items: center;\n  padding-right: 10px;\n\n  justify-content: flex-start;\n}\n\n.nav-links li.dropdown .dropdown-arrow {\n  margin-left: 5px;\n  color: #fff;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n  flex-shrink: 0;\n}\n\n.nav-links li.dropdown.open a .dropdown-arrow {\n  transform: rotate(180deg);\n}\n\n.nav-links li.dropdown .dropdown-menu {\n  display: none;\n  position: absolute;\n  top: 130%;\n  left: 0;\n  background-color: #001d4a;\n  box-shadow: 0 10px 16px rgba(0, 0, 0, 0.2);\n  padding: 0;\n  margin: 0;\n  min-width: 200px;\n  z-index: 1;\n  list-style-type: none;\n}\n\n.nav-links li.dropdown .dropdown-menu.show {\n  display: block;\n}\n\n.nav-links li.dropdown .dropdown-menu li {\n  padding: px 8px;\n  margin: 0;\n  border-bottom: 1px solid #ffffff30;\n}\n\n.nav-links li.dropdown .dropdown-menu li:last-child {\n  border-bottom: none;\n}\n\n.nav-links li.dropdown .dropdown-menu li a {\n  color: white;\n  text-decoration: none;\n  font-size: 1rem;\n}\n\n.nav-links li.dropdown .dropdown-menu li a:hover {\n  background-color: #79c42b;\n  color: white;\n}\n\n.hamburger {\n  display: none;\n  flex-direction: column;\n  cursor: pointer;\n  z-index: 20;\n}\n\n.hamburger .line {\n  width: 20px;\n  height: 3px;\n  background-color: white;\n  margin: 3px 0;\n  gap: 3px;\n  border-radius: 15%;\n  z-index: 20;\n}\n\n.navbar button {\n  background-color: transparent;\n  color: white;\n  border: none;\n  padding: 0px 0px;\n  font-size: 1.2rem;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, color 0.3s ease, transform 0.3s ease;\n}\n\n.navbar button:hover {\n  background-color: #79c42b;\n  color: white;\n  transform: scale(1.05);\n}\n\n@media (max-width: 768px) {\n  .hide-navbar-mobile {\n    display: none !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .hamburger {\n    display: flex;\n    margin-right: 10%;\n  }\n  .logo img {\n    margin-left: 30%;\n  }\n  .navbar {\n    padding: none;\n    justify-content: space-evenly;\n    gap: 200px;\n    z-index: 1000;\n  }\n  .nav-links {\n    display: none;\n    flex-direction: column;\n    position: absolute;\n    top: 70px;\n    left: 30%;\n    transform: translateX(-50%);\n    background-color: #001d4a;\n    width: 60%;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 999;\n  }\n\n  .nav-links.open {\n    display: flex;\n  }\n\n  .nav-links li {\n    padding: 8px 5px;\n    border-radius: 5px;\n\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    width: 80%;\n  }\n\n  .nav-links li a {\n    font-size: 1.2rem;\n    text-align: left;\n  }\n\n  .nav-links li.dropdown {\n    width: 100%;\n  }\n\n  .nav-links li.dropdown a {\n    display: inline-flex;\n    align-items: center;\n    padding-right: 10px;\n    justify-content: flex-start;\n  }\n\n  .nav-links li.dropdown .dropdown-arrow {\n    margin-left: 5px;\n    font-size: 0.9rem;\n    cursor: pointer;\n  }\n\n  .nav-links li.dropdown .dropdown-menu {\n    position: absolute;\n    top: 100%;\n    margin-left: -60px;\n    background-color: #001d4a;\n    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);\n    min-width: 50%;\n    text-align: left;\n  }\n\n  .nav-links li.dropdown.open .dropdown-menu {\n    display: block;\n  }\n\n  .nav-links li.dropdown .dropdown-menu li {\n    padding: 8px 10px;\n    border-bottom: 1px solid #fff;\n  }\n\n  .nav-links li.dropdown .dropdown-menu li:last-child {\n    border-bottom: none;\n  }\n\n  .nav-links li.dropdown .dropdown-menu li a {\n    color: white;\n    text-decoration: none;\n    font-size: 1rem;\n  }\n\n  .nav-links li.dropdown .dropdown-menu li a:hover {\n    background-color: #79c42b;\n    color: white;\n  }\n}\n\n@media (min-width: 769px) {\n  .hamburger {\n    display: none;\n  }\n\n  .nav-links {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n    position: static;\n    margin-right: 20px;\n  }\n\n  .nav-links li {\n    margin-left: 20px;\n    padding: 10px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, color 0.3s ease;\n  }\n\n  .nav-links li:hover {\n    background-color: #79c42b;\n    color: white;\n  }\n\n  .nav-links a {\n    text-decoration: none;\n    color: white;\n    font-size: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
